// import ct1 from '@/assets/img/home-v1/pdct-cgry-01.jpg'
// import ct2 from '@/assets/img/home-v1/pdct-cgry-01.jpg'
// import ct3 from '@/assets/img/home-v1/pdct-cgry-01.jpg'
// import ct4 from '@/assets/img/home-v1/pdct-cgry-01.jpg'
import ct1 from '@/assets/img/mirror/mirror.jpg'
import ct2 from '@/assets/img/table/table.webp'
import ct3 from '@/assets/img/sofa/sofa.jpg'
import ct4 from '@/assets/img/chair/chair1(1).jpg'

import shop1 from '@/assets/img/chair/ALEX_CHAIR.webp'
import shop2 from '@/assets/img/chair/ANTONIO_ARMCHAIR.webp'
import shop3 from '@/assets/img/chair/BEN_CHAIR/Ben_Chair.webp'
import shop3_1 from '@/assets/img/chair/BEN_CHAIR/Screenshot_(182).png'
import shop3_2 from '@/assets/img/chair/BEN_CHAIR/Screenshot_(186).png'
import shop3_3 from '@/assets/img/chair/BEN_CHAIR/Screenshot_(187).png'
import shop4 from '@/assets/img/chair/BORNEO_HANGING_CHAIR.webp'
import shop5 from '@/assets/img/chair/MORY_CHAIR_DARK_GREY.webp'
import shop6 from '@/assets/img/table/CASABIA_NESTED_TABLE.webp'
import shop7 from '@/assets/img/table/COFFEE_TABLE_INDUSTRIA.webp'
import shop8 from '@/assets/img/table/GLEN_DINING_TABLE.webp'
import shop9 from '@/assets/img/table/LYON_NESTED_TABLE_SMALL.webp'
import shop10 from '@/assets/img/table/PEACOCK_SIDE_TABLE.webp'
import shop11 from '@/assets/img/chair/ALESSA_BISTRO_ARMCHAIR/SLV-2_1.webp'
import shop12 from '@/assets/img/chair/ALESSA_BISTRO_ARMCHAIR/SLV-2_2.webp'
import shop13 from '@/assets/img/chair/ALESSA_BISTRO_ARMCHAIR/SLV-2.webp'

import shop14 from '@/assets/img/chair/ALESSA-BISTRO-ARMCHAIR-BLACK/SLV-1.webp'
import shop15 from '@/assets/img/chair/ALESSA-BISTRO-CHAIR/s1m07okk.png'
import shop16 from '@/assets/img/chair/ALOEVERA-CHAIR-BROWN-WASH/SLV-27.webp'
import shop17 from '@/assets/img/chair/ALOEVERA-CHAIR-KUBU-GREY/SLV-26_1.webp'
import shop18 from '@/assets/img/chair/ALOEVERA-CHAIR-KUBU-GREY/SLV-26.webp'

import shop19 from '@/assets/img/chair/ANTONIO-ARMCHAIR/9swfjf6p.png'
import shop20 from '@/assets/img/chair/ANTONIO-ARMCHAIR/caki8ufo.png'
import shop21 from '@/assets/img/chair/ANTONIO-ARMCHAIR/wraml4m8.png'
import shop22 from "@/assets/img/chair/BORNEO-CHAIR/BORNEO_CHAIR/SLV-28_1.webp"
import shop23 from "@/assets/img/chair/BORNEO-CHAIR/BORNEO_CHAIR/SLV-28.webp"
import shop24 from "@/assets/img/chair/BORNEO-HANGING-CHAIR/BORNEO-HANGING-CHAIR/Screenshot(199).png"
import shop25 from "@/assets/img/chair/BORNEO-HANGING-CHAIR/BORNEO-HANGING-CHAIR/Screenshot(200).png"
import shop26 from "@/assets/img/chair/BORNEO-HANGING-CHAIR/BORNEO-HANGING-CHAIR/Screenshot(201).png"
import shop27 from "@/assets/img/chair/BORNEO-HANGING-CHAIR/BORNEO-HANGING-CHAIR/Screenshot(202).png"
import shop28 from "@/assets/img/chair/BORNEO-HANGING-CHAIR/BORNEO-HANGING-CHAIR/Screenshot(203).png"
import shop29 from "@/assets/img/chair/BORNEO-HANGING-CHAIR/BORNEO-HANGING-CHAIR/Screenshot(204).png"
// shop30 ini chair
import shop30 from "@/assets/img/chair/BRYENKA-BENCH/3amy0pwe.png"
import shop31 from "@/assets/img/chair/BRYENKA-BENCH/0y1ntyjo.png"
import shop32 from "@/assets/img/chair/BRYENKA-BENCH/6tbzz3lt.png"
import shop33 from "@/assets/img/chair/BRYENKA-BENCH/390v472j.png"
import shop34 from "@/assets/img/chair/BRYENKA-BENCH/a6vujuhb.png"
import shop35 from "@/assets/img/chair/BRYENKA-BENCH/m8e0s0e6.png"
import shop36 from "@/assets/img/chair/BRYENKA-BENCH/sqojjgjm.png"



import shop37 from "@/assets/img/chair/CHIPPENDALE-ARMCHAIR/2.png"
import shop38 from "@/assets/img/chair/CHIPPENDALE-ARMCHAIR/1.png"
import shop39 from "@/assets/img/chair/CHIPPENDALE-ARMCHAIR/3.png"
import shop40 from "@/assets/img/chair/CHIPPENDALE-ARMCHAIR/4.png"
import shop41 from "@/assets/img/chair/CHIPPENDALE-ARMCHAIR/5.png"
import shop42 from "@/assets/img/chair/CHIPPENDALE-ARMCHAIR/6.png"
import shop43 from "@/assets/img/chair/CHIPPENDALE-ARMCHAIR/7.png"
import shop44 from "@/assets/img/chair/CHIPPENDALE-ARMCHAIR/8.png"
import shop45 from "@/assets/img/chair/CHIPPENDALE-ARMCHAIR/9.png"


import shop46 from "@/assets/img/chair/CREA-CHAIR/1.png"
import shop47 from "@/assets/img/chair/CREA-CHAIR/2.png"
import shop48 from "@/assets/img/chair/CREA-CHAIR/3.png"
import shop49 from "@/assets/img/chair/CREA-CHAIR/4.png"
import shop50 from "@/assets/img/chair/CREA-CHAIR/5.png"
import shop51 from "@/assets/img/chair/CREA-CHAIR/6.png"
import shop52 from "@/assets/img/chair/CREA-CHAIR/7.png"
import shop53 from "@/assets/img/chair/CREA-CHAIR/8.png"
import shop54 from "@/assets/img/chair/CREA-CHAIR/9.png"


import shop55 from "@/assets/img/chair/FLOWER-CHAIR/1.png"
import shop56 from "@/assets/img/chair/FLOWER-CHAIR/2.png"



import shop57 from "@/assets/img/chair/HERRING-STOOL/1.png"
import shop58 from "@/assets/img/chair/HERRING-STOOL/2.png"
import shop59 from "@/assets/img/chair/HERRING-STOOL/3.png"
import shop60 from "@/assets/img/chair/HERRING-STOOL/4.png"
import shop61 from "@/assets/img/chair/HERRING-STOOL/5.png"
import shop62 from "@/assets/img/chair/HERRING-STOOL/6.png"


import shop63 from "@/assets/img/chair/JUMA-CHAIR/1.webp"
import shop64 from "@/assets/img/chair/JUMA-CHAIR/2.webp"
import shop65 from "@/assets/img/chair/JUMA-CHAIR/3.webp"
import shop66 from "@/assets/img/chair/JUMA-CHAIR/4.webp"
import shop67 from "@/assets/img/chair/JUMA-CHAIR/5.webp"
import shop68 from "@/assets/img/chair/JUMA-CHAIR/6.webp"



import shop69 from "@/assets/img/chair/KELEK-KIDS-CHAIR-NATURAL/1.png"
import shop70 from "@/assets/img/chair/KELEK-KIDS-CHAIR-NATURAL/2.png"
import shop71 from "@/assets/img/chair/KELEK-KIDS-CHAIR-NATURAL/3.png"

import royalArmChair from "@/assets/img/sofa/sofa.jpg"


import shop72 from "@/assets/img/chair/KELEK-KIDS-CHAIR-WHITE/1.png"
import shop73 from "@/assets/img/chair/KELEK-KIDS-CHAIR-WHITE/2.png"

import shop74 from "@/assets/img/chair/MAX-DINING-CHAIR/1.png"
import shop75 from "@/assets/img/chair/MAX-DINING-CHAIR/2.png"
import shop76 from "@/assets/img/chair/MAX-DINING-CHAIR/3.png"
import shop77 from "@/assets/img/chair/MAX-DINING-CHAIR/4.png"
import shop78 from "@/assets/img/chair/MAX-DINING-CHAIR/5.png"
import shop79 from "@/assets/img/chair/MAX-DINING-CHAIR/6.png"
import shop80 from "@/assets/img/chair/MAX-DINING-CHAIR/7.png"

// MODIFIED PAPASAN CHAIR SKIP DAHULU

import shopPapasan1 from "@/assets/img/chair/MODIFIED-PAPASAN-CHAIR/1.png"
import shopPapasan2 from "@/assets/img/chair/MODIFIED-PAPASAN-CHAIR/2.png"
import shopPapasan3 from "@/assets/img/chair/MODIFIED-PAPASAN-CHAIR/3.png"
import shopPapasan4 from "@/assets/img/chair/MODIFIED-PAPASAN-CHAIR/4.png"
import shopPapasan5 from "@/assets/img/chair/MODIFIED-PAPASAN-CHAIR/5.png"
import shopPapasan6 from "@/assets/img/chair/MODIFIED-PAPASAN-CHAIR/6.png"
import shopPapasan7 from "@/assets/img/chair/MODIFIED-PAPASAN-CHAIR/7.png"
import shopPapasan8 from "@/assets/img/chair/MODIFIED-PAPASAN-CHAIR/8.png"


import shop81 from "@/assets/img/chair/MORY-CHAIR-LIGHT-GREY/Screenshot(174).png"
import shop82 from "@/assets/img/chair/MORY-CHAIR-LIGHT-GREY/Screenshot(175).png"
import shop83 from "@/assets/img/chair/MORY-CHAIR-LIGHT-GREY/Screenshot(176).png"
import shop84 from "@/assets/img/chair/MORY-CHAIR-LIGHT-GREY/Screenshot(177).png"
import shop85 from "@/assets/img/chair/MORY-CHAIR-LIGHT-GREY/Screenshot(178).png"
import shop86 from "@/assets/img/chair/MORY-CHAIR-LIGHT-GREY/Screenshot(179).png"


import shop87 from "@/assets/img/chair/ORLON-ARMCHAIR/1.webp"


import shop88 from "@/assets/img/chair/PAUL-BARSTOOL/1.webp"
import shop89 from "@/assets/img/chair/PAUL-BARSTOOL/2.webp"


import shop90 from "@/assets/img/chair/PAUL-DINING-CHAIR/1.png"
import shop91 from "@/assets/img/chair/PAUL-DINING-CHAIR/2.png"
import shop92 from "@/assets/img/chair/PAUL-DINING-CHAIR/3.png"


import shop93 from "@/assets/img/chair/PEACOCK-ARMCHAIR-BLUE/1.png"


import shop94 from "@/assets/img/chair/PEACOCK-ARMCHAIR-RED/1.png"

import shop95 from "@/assets/img/chair/PEACOCK-ARMCHAIR-YELLOW/1.png"

import shop96 from "@/assets/img/chair/PEACOCK-DINING-CHAIR/1.png"
import shop97 from "@/assets/img/chair/PEACOCK-DINING-CHAIR/2.png"
import shop98 from "@/assets/img/chair/PEACOCK-DINING-CHAIR/3.png"
import shop99 from "@/assets/img/chair/PEACOCK-DINING-CHAIR/4.png"
import shop100 from "@/assets/img/chair/PEACOCK-DINING-CHAIR/5.png"
import shop101 from "@/assets/img/chair/PEACOCK-DINING-CHAIR/6.png"
import shop102 from "@/assets/img/chair/PEACOCK-DINING-CHAIR/7.png"
import shop103 from "@/assets/img/chair/PEACOCK-DINING-CHAIR/8.png"



import shop104 from "@/assets/img/chair/PROVENCE-WALL-SHELVES/1.png"
import shop105 from "@/assets/img/chair/PROVENCE-WALL-SHELVES/2.png"
import shop106 from "@/assets/img/chair/PROVENCE-WALL-SHELVES/3.png"
import shop107 from "@/assets/img/chair/PROVENCE-WALL-SHELVES/4.png"
import shop108 from "@/assets/img/chair/PROVENCE-WALL-SHELVES/5.png"


import shop109 from "@/assets/img/chair/SLOUCH-CHAIR/1.png"
import shop110 from "@/assets/img/chair/SLOUCH-CHAIR/2.png"
import shop111 from "@/assets/img/chair/SLOUCH-CHAIR/3.png"
import shop112 from "@/assets/img/chair/SLOUCH-CHAIR/4.png"
import shop113 from "@/assets/img/chair/SLOUCH-CHAIR/5.png"
import shop114 from "@/assets/img/chair/SLOUCH-CHAIR/6.png"


// import shop114 from "@/assets/img/chair/SLOUCH-STOOL/1.png"
import shop115 from "@/assets/img/chair/SLOUCH-STOOL/2.png"
import shop116 from "@/assets/img/chair/SLOUCH-STOOL/3.png"
import shop117 from "@/assets/img/chair/SLOUCH-STOOL/4.png"
import shop118 from "@/assets/img/chair/SLOUCH-STOOL/5.png"
import shop119 from "@/assets/img/chair/SLOUCH-STOOL/6.png"


import shop120 from "@/assets/img/chair/SQUARE-BISTRO-ARMCHAIR/1.webp"
import shop121 from "@/assets/img/chair/SQUARE-BISTRO-ARMCHAIR/2.webp"

import shop122 from "@/assets/img/chair/STELLA-HANGING-CHAIR/1.png"
import shop123 from "@/assets/img/chair/STELLA-HANGING-CHAIR/2.png"


import shop124 from "@/assets/img/chair/TAKESHI-CHAIR/1.webp"
import shop125 from "@/assets/img/chair/TAKESHI-CHAIR/2.webp"
import shop126 from "@/assets/img/chair/TAKESHI-CHAIR/3.webp"
import shop127 from "@/assets/img/chair/TAKESHI-CHAIR/4.webp"
import shop128 from "@/assets/img/chair/TAKESHI-CHAIR/5.webp"
import shop129 from "@/assets/img/chair/TAKESHI-CHAIR/6.webp"
import shop130 from "@/assets/img/chair/TAKESHI-CHAIR/7.webp"
import shop131 from "@/assets/img/chair/TAKESHI-CHAIR/8.webp"


import shop132 from "@/assets/img/chair/TIFFANY-DINING-CHAIR/1.png"
import shop133 from "@/assets/img/chair/TIFFANY-DINING-CHAIR/2.png"
import shop134 from "@/assets/img/chair/TIFFANY-DINING-CHAIR/3.png"


import shop135 from "@/assets/img/chair/TUB-BISTRO-ARMCHAIR/1.png"

import shop136 from "@/assets/img/chair/WEBBING-DINING-CHAIR/1.png"
import shop137 from "@/assets/img/chair/WEBBING-DINING-CHAIR/2.png"
import shop138 from "@/assets/img/chair/WEBBING-DINING-CHAIR/3.png"
import shop139 from "@/assets/img/chair/WEBBING-DINING-CHAIR/4.png"
import shop140 from "@/assets/img/chair/WEBBING-DINING-CHAIR/5.png"
import shop141 from "@/assets/img/chair/WEBBING-DINING-CHAIR/6.png"
import shop142 from "@/assets/img/chair/WEBBING-DINING-CHAIR/7.png"


import shop143 from "@/assets/img/chair/YOSEPH-PEEL-DINING-CHAIR/1.png"

import shop145 from "@/assets/img/chair/ZB-RATTAN-CHAIR/1.webp"
import shop146 from "@/assets/img/chair/ZB-RATTAN-CHAIR/2.webp"
import shop147 from "@/assets/img/chair/ZB-RATTAN-CHAIR/3.webp"
import shop148 from "@/assets/img/chair/ZB-RATTAN-CHAIR/4.webp"
import shop149 from "@/assets/img/chair/ZB-RATTAN-CHAIR/5.webp"
import shop150 from "@/assets/img/chair/ZB-RATTAN-CHAIR/6.webp"




// Table
import shop151 from "@/assets/img/table/BREW-DINING-TABLE/9eh5sksw.png"
import shop152 from "@/assets/img/table/BREW-DINING-TABLE/ouq7bkbe.png"


import shop153 from "@/assets/img/table/BRYENKA-BENCH/0y1ntyjo.png"
import shop154 from "@/assets/img/table/BRYENKA-BENCH/3amy0pwe.png"
import shop155 from "@/assets/img/table/BRYENKA-BENCH/6tbzz3lt.png"
import shop156 from "@/assets/img/table/BRYENKA-BENCH/390v472j.png"
import shop157 from "@/assets/img/table/BRYENKA-BENCH/a6vujuhb.png"
import shop158 from "@/assets/img/table/BRYENKA-BENCH/m5gghg1s.png"
import shop159 from "@/assets/img/table/BRYENKA-BENCH/m8e0s0e6.png"
import shop160 from "@/assets/img/table/BRYENKA-BENCH/sqojjgjm.png"



import shop161 from "@/assets/img/table/CASABIA-NESTED-TABLE/1tr2it8k.png"
import shop162 from "@/assets/img/table/CASABIA-NESTED-TABLE/4wegyjwq.png"
import shop163 from "@/assets/img/table/CASABIA-NESTED-TABLE/5tixh4hg.png"
import shop164 from "@/assets/img/table/CASABIA-NESTED-TABLE/iwk2pvcb.png"
import shop165 from "@/assets/img/table/CASABIA-NESTED-TABLE/lhmghj6n.png"
import shop166 from "@/assets/img/table/CASABIA-NESTED-TABLE/m87xeftv.png"



import shop167 from "@/assets/img/table/COFFEE-TABLE-INDUSTRIA/1.png"

import shop168 from "@/assets/img/table/GLEN-DINING-TABLE/1.png"
import shop169 from "@/assets/img/table/GLEN-DINING-TABLE/2.png"
import shop170 from "@/assets/img/table/GLEN-DINING-TABLE/3.png"
import shop171 from "@/assets/img/table/GLEN-DINING-TABLE/4.png"
import shop172 from "@/assets/img/table/GLEN-DINING-TABLE/5.png"

import shop173 from "@/assets/img/table/LYON-NESTED-TABLE-BIG/1.png"
import shop174 from "@/assets/img/table/LYON-NESTED-TABLE-BIG/2.png"
import shop175 from "@/assets/img/table/LYON-NESTED-TABLE-BIG/3.png"
import shop176 from "@/assets/img/table/LYON-NESTED-TABLE-BIG/4.png"
import shop177 from "@/assets/img/table/LYON-NESTED-TABLE-BIG/5.png"



import shop178 from "@/assets/img/table/LYON-NESTED-TABLE-SMALL/1.png"
import shop179 from "@/assets/img/table/LYON-NESTED-TABLE-SMALL/2.png"
import shop180 from "@/assets/img/table/LYON-NESTED-TABLE-SMALL/3.png"
import shop181 from "@/assets/img/table/LYON-NESTED-TABLE-SMALL/4.png"


import shop182 from "@/assets/img/table/PEACOCK-COFFEE-TABLE/1.png"

import shop183 from "@/assets/img/table/PEACOCK-SIDE-TABLE/1.png"

import shop184 from "@/assets/img/table/TAYLOR-DESK/1.png"
import shop185 from "@/assets/img/table/TAYLOR-DESK/2.png"
import shop186 from "@/assets/img/table/TAYLOR-DESK/3.png"
import shop187 from "@/assets/img/table/TAYLOR-DESK/4.png"
import shop188 from "@/assets/img/table/TAYLOR-DESK/5.png"
import shop189 from "@/assets/img/table/TAYLOR-DESK/6.png"
import shop190 from "@/assets/img/table/TAYLOR-DESK/7.png"

// sofa
import shop191 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_1.webp"
import shop192 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_2.webp"
import shop193 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_3.webp"
import shop194 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_4.webp"
import shop195 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_5.webp"
import shop196 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_6.webp"
import shop197 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_7.webp"
import shop198 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_8.webp"
import shop199 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_9.webp"
import shop200 from "@/assets/img/sofa/BLOOM-LOUNGE-SOFA/SLV-368334_10.webp"


// MIRROR
import shop201 from "@/assets/img/mirror/ANATOLIA-MIRROR/3p8c6qn3.png"
import shop202 from "@/assets/img/mirror/ANATOLIA-MIRROR/6dej2969.png"
import shop203 from "@/assets/img/mirror/ANATOLIA-MIRROR/3p8c6qn3.png"



















import fea1 from '@/assets/img/svg/fea-1.svg'
import fea2 from '@/assets/img/svg/fea-2.svg'
import fea3 from '@/assets/img/svg/fea-3.svg'
import fea4 from '@/assets/img/svg/fea-4.svg'
import fea5 from '@/assets/img/svg/fea-5.svg'

import blog1 from '@/assets/img/shortcode/blog/blog-22.jpg'
import blog2 from '@/assets/img/shortcode/blog/blog-23.jpg'
import blog3 from '@/assets/img/shortcode/blog/blog-24.jpg'
import blog4 from '@/assets/img/shortcode/blog/blog-25.jpg'
import blog5 from '@/assets/img/shortcode/blog/blog-26.jpg'
import blog6 from '@/assets/img/shortcode/blog/blog-27.jpg'
import blog7 from '@/assets/img/shortcode/blog/blog-28.jpg'
import blog8 from '@/assets/img/shortcode/blog/blog-29.jpg'

import blog01 from '@/assets/img/home-v2/blog-01.jpg'
import blog02 from '@/assets/img/home-v2/blog-02.jpg'
import blog03 from '@/assets/img/home-v2/blog-03.jpg'

import partner1 from '@/assets/img/partner/partner-1.svg'
import partner2 from '@/assets/img/partner/partner-2.svg'
import partner3 from '@/assets/img/partner/partner-3.svg'
import partner4 from '@/assets/img/partner/partner-4.svg'
import partner5 from '@/assets/img/partner/partner-5.svg'
import partner6 from '@/assets/img/partner/partner-6.svg'
import partner7 from '@/assets/img/partner/partner-7.svg'
import partner8 from '@/assets/img/partner/partner-8.svg'
import partner9 from '@/assets/img/partner/partner-9.svg'
import partner10 from '@/assets/img/partner/partner-10.svg'
import partner11 from '@/assets/img/partner/partner-11.svg'
import partner12 from '@/assets/img/partner/partner-12.svg'
import partner13 from '@/assets/img/partner/partner-13.svg'
import partner14 from '@/assets/img/partner/partner-14.svg'
import partner15 from '@/assets/img/partner/partner-15.svg'

import partner01 from '@/assets/img/partner/partner-light-1.svg'
import partner02 from '@/assets/img/partner/partner-light-2.svg'
import partner03 from '@/assets/img/partner/partner-light-3.svg'
import partner04 from '@/assets/img/partner/partner-light-4.svg'
import partner05 from '@/assets/img/partner/partner-light-5.svg'
import partner06 from '@/assets/img/partner/partner-light-6.svg'
import partner07 from '@/assets/img/partner/partner-light-7.svg'
import partner08 from '@/assets/img/partner/partner-light-8.svg'
import partner09 from '@/assets/img/partner/partner-light-9.svg'
import partner010 from '@/assets/img/partner/partner-light-10.svg'
import partner011 from '@/assets/img/partner/partner-light-11.svg'
import partner012 from '@/assets/img/partner/partner-light-12.svg'
import partner013 from '@/assets/img/partner/partner-light-13.svg'
import partner014 from '@/assets/img/partner/partner-light-14.svg'
import partner015 from '@/assets/img/partner/partner-light-15.svg'

import product1 from '@/assets/img/home-v2/product/pdct-01.jpg'
import product2 from '@/assets/img/home-v2/product/pdct-02.jpg'
import product3 from '@/assets/img/home-v2/product/pdct-03.jpg'
import product4 from '@/assets/img/home-v2/product/pdct-04.jpg'

import team2 from '@/assets/img/pulman/pulman1(1).png'
import team3 from '@/assets/img/acta/acta5.png'

import team01 from '@/assets/img/team/team-01.jpg'
import team02 from '@/assets/img/team/team-02.jpg'
import team03 from '@/assets/img/team/team-03.jpg'
import team04 from '@/assets/img/team/team-04.jpg'
import team05 from '@/assets/img/team/team-05.jpg'
import team06 from '@/assets/img/team/team-06.jpg'

import cart1 from '@/assets/img/gallery/cart/cart-01.jpg'
import cart2 from '@/assets/img/gallery/cart/cart-02.jpg'
import cart3 from '@/assets/img/gallery/cart/cart-03.jpg'
import cart4 from '@/assets/img/gallery/cart/cart-04.jpg'
import cart5 from '@/assets/img/gallery/cart/cart-05.jpg'

import shop01 from '@/assets/img/gallery/shop-04/shop-01.jpg'
import shop02 from '@/assets/img/gallery/shop-04/shop-02.jpg'
import shop03 from '@/assets/img/gallery/shop-04/shop-03.jpg'
import shop04 from '@/assets/img/gallery/shop-04/shop-04.jpg'
import shop05 from '@/assets/img/gallery/shop-04/shop-05.jpg'
import shop06 from '@/assets/img/gallery/shop-04/shop-06.jpg'
import shop07 from '@/assets/img/gallery/shop-04/shop-07.jpg'
import shop08 from '@/assets/img/gallery/shop-04/shop-08.jpg'
import shop09 from '@/assets/img/gallery/shop-04/shop-09.jpg'




    export const categoryOne = [
        {
            id: 1,
            image:ct1,
            item:'1 items',
            name:'Mirror',
            slug : "mirror"
        },
        {
            id : 2,
            image:ct2,
            item:'15 items',
            name:'Table',
            slug : "table"
        },
        {
            id : 3,
            image:ct3,
            item:'1 items',
            name:'Sofa',
            slug : "sofa"
        },
        {
            id : 4,
            image:ct4,
            item:'37 items',
            name:'Chair',
            slug : "chair"
        },

    ]

export const productList = [
    {
        id:1,
        image:shop1,
        tag:'',
        price:'1,350,000.00',
        Heightdiameter : "DIAM.W x D x H CM",
        material : "SUNGKAI WOOD FRAME",
        packaging : "FABRIC BY CLIENT (APPROX NEED 1.5 METER)",
        name:'Alex Chair',
        categorySlug : "chair"
    },
    {
        id:2,
        image:shop2,
        tag:'',
        // tag:'NEW',
        price:'',
        name:'Antonio ArmChair',
        categorySlug : "chair"
    },
    {
        id:3,
        image:shop3,
        tag:'',
        // tag:'10% OFF',
        price:'1.400.000',
        name:'Ben Chair',
        Heightdiameter : "",
        material : "UNGKAI WOOD FRAME",
        packaging : "FABRIC BY CLIENT (APPROX NEED 1.5 METER)",
        categorySlug : "chair"
    },
    {
        id:4,
        image:shop4,
        tag:'',
        price:'',
        name:'Borneo Hanging Chair',
        categorySlug : "chair",
    },
    {
        id:5,
        image:shop5,
        tag:'',
        // tag:'Hot Sale',
        price:'1,050,000.00',
        Heightdiameter : "DIAM. 52 x H 52 CM",
        material : "IRON FRAME = WHITE PC NATURAL RATTAN CORE / PITRIT : NATURAL",
        packaging : "Single Face Paper",
        name:'Mory Chair Dark Grey',
        categorySlug : "chair"
    },
    {
        id:6,
        image:shop6,
        tag:'',
        price:'',
        name:'CASABIA_NESTED_TABLE',
        categorySlug : "table",
    },
    {
        id:7,
        image:shop7,
        tag:'',
        price:'',
        name:'COFFEE_TABLE_INDUSTRIA',
        categorySlug : "table"

    },
    {
        id:8,
        image:shop8,
        tag:'',
        price:'',
        name:'GLEN_DINING_TABLE',
        categorySlug : "table"
    },
    {
        id:9,
        image:shop9,
        tag:'',
        price:'500,000.00',
        name:'LYON_NESTED_TABLE_SMALL',
        categorySlug : "table"
    },
    {
        id:10,
        image:shop10,
        tag:'',
        price:'',
        name:'PEACOCK_SIDE_TABLE',
        categorySlug : "table"
    },
    {
        id:11,
        image:shop3_1,
        tag:'',
        price:'1.400.000',
        name:'Ben Chair',
        categorySlug : "chair"
    },
    {
        id:12,
        image:shop3_2,
        tag:'',
        price:'1.400.000',
        name:'Ben Chair',
        categorySlug : "chair"
    },
    {
        id:13,
        image:shop3_3,
        tag:'',
        price:'1.400.000',
        name:'Ben Chair',
        categorySlug : "chair"
    },
    {
        id:14,
        image:shop11,
        tag:'',
        price:'',
        name:'Alessa Bistro ArmChair',
        categorySlug : "chair"
    },
    {
        id:15,
        image:shop12,
        tag:'',
        price:'',
        name:'Alessa Bistro ArmChair',
        categorySlug : "chair"
    },
    {
        id:16,
        image:shop13,
        tag:'',
        price:'',
        name:'Alessa Bistro ArmChair',
        categorySlug : "chair"
    },
    {
        id:17,
        image:shop14,
        tag:'',
        price:'',
        name:'Alessa Bistro ArmChair Black',
        categorySlug : "chair"
    },
    {
        id:18,
        image:shop15,
        tag:'',
        price:'',
        name:'Alessa Bistro Chair',
        categorySlug : "chair"
    },
    {
        id:19,
        image:shop16,
        tag:'',
        price:'',
        name:'Aloevera Chair Brown Wash',
        categorySlug : "chair"
    },
    {
        id:20,
        image:shop17,
        tag:'',
        price:'',
        name:'Aloevera Chair Kubu Grey',
        categorySlug : "chair"
    },
    {
        id:21,
        image:shop18,
        tag:'',
        price:'',
        name:'Aloevera Chair Kubu Grey',
        categorySlug : "chair"
    },
    {
        id:22,
        image:shop19,
        tag:'',
        price:'',
        name:'Antonio ArmChair',
        categorySlug : "chair"
    },
    {
        id:23,
        image:shop20,
        tag:'',
        price:'',
        name:'Antonio ArmChair',
        categorySlug : "chair"
    },
    {
        id:24,
        image:shop21,
        tag:'',
        price:'',
        name:'Antonio ArmChair',
        categorySlug : "chair"
    },
    {
        id:25,
        image:shop22,
        tag:'',
        price:'',
        name:'Borneo Chair',
        categorySlug : "chair"
    },
    {
        id:26,
        image:shop23,
        tag:'',
        price:'',
        name:'Borneo Hanging Chair',
        categorySlug : "chair"
    },
    {
        id:27,
        image:shop24,
        tag:'',
        price:'',
        name:'Borneo Hanging Chair',
        categorySlug : "chair"
    },
    {
        id:28,
        image:shop25,
        tag:'',
        price:'',
        name:'Borneo Hanging Chair',
        categorySlug : "chair"
    },
    {
        id:29,
        image:shop26,
        tag:'',
        price:'',
        name:'Borneo Hanging Chair',
        categorySlug : "chair"
    },
    {
        id:30,
        image:shop27,
        tag:'',
        price:'',
        name:'Borneo Hanging Chair',
        categorySlug : "chair"
    },
    {
        id:31,
        image:shop28,
        tag:'',
        price:'',
        name:'Borneo Hanging Chair',
        categorySlug : "chair"
    },
    {
        id:32,
        image:shop29,
        tag:'',
        price:'',
        name:'Borneo Hanging Chair',
        categorySlug : "chair"
    },
    {
        id:33,
        image:shop30,
        tag:'',
        price:'1,500,000.00',
        name:'Bryenka Bench',
        categorySlug : "chair"
    },
    {
        id:34,
        image:shop31,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "chair"
    },
    {
        id:35,
        image:shop32,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "chair"
    },
    {
        id:36,
        image:shop33,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "chair"
    },
    {
        id:37,
        image:shop34,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "chair"
    },
    {
        id:38,
        image:shop35,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "chair"
    },
    {
        id:39,
        image:shop36,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "chair"
    },
    {
        id:40,
        image:shop37,
        tag:'',
        price:'',
        name:'Chippendale Armchair',
        categorySlug : "chair"
    },
    {
        id:41,
        image:shop38,
        tag:'',
        price:'',
        name:'Chippendale Armchair',
        categorySlug : "chair"
    },
    {
        id:42,
        image:shop39,
        tag:'',
        price:'',
        name:'Chippendale Armchair',
        categorySlug : "chair"
    },
    {
        id:43,
        image:shop40,
        tag:'',
        price:'',
        name:'Chippendale Armchair',
        categorySlug : "chair"
    },
    {
        id:44,
        image:shop41,
        tag:'',
        price:'',
        name:'Chippendale Armchair',
        categorySlug : "chair"
    },
    {
        id:45,
        image:shop42,
        tag:'',
        price:'',
        name:'Chippendale Armchair',
        categorySlug : "chair"
    },
    {
        id:46,
        image:shop43,
        tag:'',
        price:'',
        name:'Chippendale Armchair',
        categorySlug : "chair"
    },
    {
        id:47,
        image:shop44,
        tag:'',
        price:'',
        name:'Chippendale Armchair',
        categorySlug : "chair"
    },
    {
        id:49,
        image:shop45,
        tag:'',
        price:'',
        name:'Chippendale Armchair',
        categorySlug : "chair"
    },
    {
        id:50,
        image:shop46,
        tag:'',
        price:'1,150,000.00',
        Heightdiameter : "DIAM.  W 50 x D 51 x H 40  CM",
        material : "TEAK WOOD ",
        packaging : "",
        name:'Crea Chair',
        categorySlug : "chair"
    },
    {
        id:51,
        image:shop47,
        tag:'',
        price:'',
        name:'Crea Chair',
        categorySlug : "chair"
    },
    {
        id:52,
        image:shop48,
        tag:'',
        price:'',
        name:'Crea Chair',
        categorySlug : "chair"
    },
    {
        id:53,
        image:shop49,
        tag:'',
        price:'',
        name:'Crea Chair',
        categorySlug : "chair"
    },
    {
        id:54,
        image:shop50,
        tag:'',
        price:'',
        name:'Crea Chair',
        categorySlug : "chair"
    },
    {
        id:55,
        image:shop51,
        tag:'',
        price:'',
        name:'Crea Chair',
        categorySlug : "chair"
    },
    {
        id:56,
        image:shop52,
        tag:'',
        price:'',
        name:'Crea Chair',
        categorySlug : "chair"
    },
    {
        id:57,
        image:shop53,
        tag:'',
        price:'',
        name:'Crea Chair',
        categorySlug : "chair"
    },
    {
        id:58,
        image:shop54,
        tag:'',
        price:'',
        name:'Crea Chair',
        categorySlug : "chair"
    },
    {
        id:58,
        image:shop55,
        tag:'',
        price:'',
        name:'Flower Chair',
        categorySlug : "chair"
    },
    {
        id:59,
        image:shop56,
        tag:'',
        price:'',
        name:'Flower Chair',
        categorySlug : "chair"
    },
    {
        id:60,
        image:shop57,
        tag:'',
        price:'',
        name:'Herring Stoll',
        categorySlug : "chair"
    },
    {
        id:61,
        image:shop58,
        tag:'',
        price:'',
        name:'Herring Stoll',
        categorySlug : "chair"
    },
    {
        id:62,
        image:shop59,
        tag:'',
        price:'',
        name:'Herring Stoll',
        categorySlug : "chair"
    },
    {
        id:63,
        image:shop60,
        tag:'',
        price:'',
        name:'Herring Stoll',
        categorySlug : "chair"
    },
    {
        id:64,
        image:shop61,
        tag:'',
        price:'',
        name:'Herring Stoll',
        categorySlug : "chair"
    },
    {
        id:65,
        image:shop62,
        tag:'',
        price:'',
        name:'Herring Stoll',
        categorySlug : "chair"
    },
    {
        id:66,
        image:shop63,
        tag:'',
        price:'1,850,000.00',
        Heightdiameter : "W x D x H CM",
        material : "RON FRAME (BLACK POWDER COATED)",
        packaging : "ABRIC BY CLIENT (APPROX BUTUH 0.7 METER)",
        name:'Juma Chair',
        categorySlug : "chair"
    },
    {
        id:67,
        image:shop64,
        tag:'',
        price:'',
        name:'Juma Chair',
        categorySlug : "chair"
    },
    {
        id:68,
        image:shop65,
        tag:'',
        price:'',
        name:'Juma Chair',
        categorySlug : "chair"
    },
    {
        id:69,
        image:shop66,
        tag:'',
        price:'',
        name:'Juma Chair',
        categorySlug : "chair"
    },
    {
        id:70,
        image:shop67,
        tag:'',
        price:'',
        name:'Juma Chair',
        categorySlug : "chair"
    },
    {
        id:71,
        image:shop68,
        tag:'',
        price:'',
        name:'Juma Chair',
        categorySlug : "chair"
    },
    {
        id:72,
        image:shop69,
        tag:'',
        price:'',
        name:'Kelek Kids Chair Natural',
        categorySlug : "chair"
    },
    {
        id:73,
        image:shop70,
        tag:'',
        price:'',
        name:'Kelek Kids Chair Natural',
        categorySlug : "chair"
    },
    {
        id:74,
        image:shop71,
        tag:'',
        price:'',
        name:'Kelek Kids Chair Natural',
        categorySlug : "chair"
    },
    {
        id:75,
        image:shop72,
        tag:'',
        price:'',
        name:'Kelek Kids Chair White',
        categorySlug : "chair"
    },
    {
        id:76,
        image:shop73,
        tag:'',
        price:'',
        name:'Kelek Kids Chair White',
        categorySlug : "chair"
    },
    {
        id:77,
        image:shop74,
        tag:'',
        price:'',
        name:'Max Dining Chair',
        categorySlug : "chair"
    },
    {
        id:78,
        image:shop75,
        tag:'',
        price:'',
        name:'Max Dining Chair',
        categorySlug : "chair"
    },
    {
        id:79,
        image:shop76,
        tag:'',
        price:'',
        name:'Max Dining Chair',
        categorySlug : "chair"
    },
    {
        id:80,
        image:shop77,
        tag:'',
        price:'',
        name:'Max Dining Chair',
        categorySlug : "chair"
    },
    {
        id:81,
        image:shop78,
        tag:'',
        price:'',
        name:'Max Dining Chair',
        categorySlug : "chair"
    },
    {
        id:82,
        image:shop79,
        tag:'',
        price:'',
        name:'Max Dining Chair',
        categorySlug : "chair"
    },
    {
        id:83,
        image:shop80,
        tag:'',
        price:'',
        name:'Max Dining Chair',
        categorySlug : "chair"
    },
    {
        id:84,
        image:shop81,
        tag:'',
        price:'',
        name:'Mory Chair Light Grey',
        categorySlug : "chair"
    },
    {
        id:85,
        image:shop82,
        tag:'',
        price:'',
        name:'Mory Chair Light Grey',
        categorySlug : "chair"
    },
    {
        id:86,
        image:shop83,
        tag:'',
        price:'',
        name:'Mory Chair Light Grey',
        categorySlug : "chair"
    },
    {
        id:87,
        image:shop84,
        tag:'',
        price:'',
        name:'Mory Chair Light Grey',
        categorySlug : "chair"
    },
    {
        id:88,
        image:shop85,
        tag:'',
        price:'',
        name:'Mory Chair Light Grey',
        categorySlug : "chair"
    },
    {
        id:89,
        image:shop86,
        tag:'',
        price:'',
        name:'Mory Chair Light Grey',
        categorySlug : "chair"
    },
    {
        id:90,
        image:shop87,
        tag:'',
        price:'',
        name:'Orlon Chair',
        categorySlug : "chair"
    },
    {
        id:91,
        image:shop88,
        tag:'',
        price:'',
        name:'Paul Barstool',
        categorySlug : "chair"
    },
    {
        id:92,
        image:shop89,
        tag:'',
        price:'',
        name:'Paul Barstool',
        categorySlug : "chair"
    },
    {
        id:93,
        image:shop90,
        tag:'',
        price:'',
        name:'Paul Dining Chair',
        categorySlug : "chair"
    },
    {
        id:94,
        image:shop91,
        tag:'',
        price:'',
        name:'Paul Dining Chair',
        categorySlug : "chair"
    },
    {
        id:95,
        image:shop92,
        tag:'',
        price:'',
        name:'Paul Dining Chair',
        categorySlug : "chair"
    },
    {
        id:96,
        image:shop93,
        tag:'',
        price:'',
        name:'Peacock Armchair Blue',
        categorySlug : "chair"
    },
    {
        id:97,
        image:shop94,
        tag:'',
        price:'',
        name:'Peacock Armchair Red',
        categorySlug : "chair"
    },
    {
        id:98,
        image:shop95,
        tag:'',
        price:'',
        name:'Peacock Armchair Yellow',
        categorySlug : "chair"
    },
    {
        id:99,
        image:shop96,
        tag:'',
        price:'',
        name:'Peacock Dining Chair',
        categorySlug : "chair"
    },
    {
        id:100,
        image:shop97,
        tag:'',
        price:'',
        name:'Peacock Dining Chair',
        categorySlug : "chair"
    },
    {
        id:101,
        image:shop98,
        tag:'',
        price:'',
        name:'Peacock Dining Chair',
        categorySlug : "chair"
    },
    {
        id:102,
        image:shop99,
        tag:'',
        price:'',
        name:'Peacock Dining Chair',
        categorySlug : "chair"
    },
    {
        id:103,
        image:shop100,
        tag:'',
        price:'',
        name:'Peacock Dining Chair',
        categorySlug : "chair"
    },
    {
        id:104,
        image:shop101,
        tag:'',
        price:'',
        name:'Peacock Dining Chair',
        categorySlug : "chair"
    },
    {
        id:105,
        image:shop102,
        tag:'',
        price:'',
        name:'Peacock Dining Chair',
        categorySlug : "chair"
    },
    {
        id:106,
        image:shop103,
        tag:'',
        price:'',
        name:'Peacock Dining Chair',
        categorySlug : "chair"
    },
    {
        id:106,
        image:shop104,
        tag:'',
        price:'',
        name:'Peacock Dining Chair',
        categorySlug : "chair"
    },
    {
        id:107,
        image:shop105,
        tag:'',
        price:'',
        name:'Provence Wall Shelves',
        categorySlug : "chair"
    },
    {
        id:108,
        image:shop106,
        tag:'',
        price:'',
        name:'Provence Wall Shelves',
        categorySlug : "chair"
    },
    {
        id:109,
        image:shop107,
        tag:'',
        price:'',
        name:'Provence Wall Shelves',
        categorySlug : "chair"
    },
    {
        id:110,
        image:shop108,
        tag:'',
        price:'',
        name:'Provence Wall Shelves',
        categorySlug : "chair"
    },
    {
        id:111,
        image:shop109,
        tag:'',
        price:'',
        name:'Provence Wall Shelves',
        categorySlug : "chair"
    },
    {
        id:112,
        image:shop110,
        tag:'',
        price:'',
        name:'Slouch Chair',
        categorySlug : "chair"
    },
    {
        id:113,
        image:shop111,
        tag:'',
        price:'',
        name:'Slouch Chair',
        categorySlug : "chair"
    },
    {
        id:114,
        image:shop112,
        tag:'',
        price:'',
        name:'Slouch Chair',
        categorySlug : "chair"
    },
    {
        id:115,
        image:shop113,
        tag:'',
        price:'',
        name:'Slouch Chair',
        categorySlug : "chair"
    },
    {
        id:116,
        image:shop114,
        tag:'',
        price:'',
        name:'Slouch Chair',
        categorySlug : "chair"
    },
    {
        id:117,
        image:shop115,
        tag:'',
        price:'',
        name:'Slouch Chair',
        categorySlug : "chair"
    },
    {
        id:118,
        image:shop116,
        tag:'',
        price:'',
        name:'Slouch Stool',
        categorySlug : "chair"
    },
    {
        id:119,
        image:shop117,
        tag:'',
        price:'',
        name:'Slouch Stool',
        categorySlug : "chair"
    },
    {
        id:120,
        image:shop118,
        tag:'',
        price:'',
        name:'Slouch Stool',
        categorySlug : "chair"
    },
    {
        id:121,
        image:shop119,
        tag:'',
        price:'',
        name:'Slouch Stool',
        categorySlug : "chair"
    },
    {
        id:122,
        image:shop120,
        tag:'',
        price:'',
        name:'Square Bistro Armchair',
        categorySlug : "chair"
    },
    {
        id:123,
        image:shop121,
        tag:'',
        price:'',
        name:'Square Bistro Armchair',
        categorySlug : "chair"
    },
    {
        id:124,
        image:shop122,
        tag:'',
        price:'',
        name:'Stella Hanging Chair',
        categorySlug : "chair"
    },
    {
        id:125,
        image:shop123,
        tag:'',
        price:'',
        name:'Stella Hanging Chair',
        categorySlug : "chair"
    },
    {
        id:126,
        image:shop124,
        tag:'',
        price:'900.000,00',
        Heightdiameter : "",
        material : "SUNGKAI WOOD ",
        packaging : "",
        name:'Takeshi Chair',
        categorySlug : "chair"
    },
    {
        id:127,
        image:shop125,
        tag:'',
        price:'',
        name:'Takeshi Chair',
        categorySlug : "chair"
    },
    {
        id:128,
        image:shop126,
        tag:'',
        price:'',
        name:'Takeshi Chair',
        categorySlug : "chair"
    },
    {
        id:129,
        image:shop127,
        tag:'',
        price:'',
        name:'Takeshi Chair',
        categorySlug : "chair"
    },
    {
        id:130,
        image:shop128,
        tag:'',
        price:'',
        name:'Takeshi Chair',
        categorySlug : "chair"
    },
    {
        id:131,
        image:shop129,
        tag:'',
        price:'',
        name:'Takeshi Chair',
        categorySlug : "chair"
    },
    {
        id:132,
        image:shop130,
        tag:'',
        price:'',
        name:'Takeshi Chair',
        categorySlug : "chair"
    },
    {
        id:133,
        image:shop131,
        tag:'',
        price:'',
        name:'Takeshi Chair',
        categorySlug : "chair"
    },
    {
        id:134,
        image:shop132,
        tag:'',
        price:'',
        name:'Tiffany Dining Chair',
        categorySlug : "chair"
    },
    {
        id:135,
        image:shop133,
        tag:'',
        price:'',
        name:'Tiffany Dining Chair',
        categorySlug : "chair"
    },
    {
        id:136,
        image:shop133,
        tag:'',
        price:'',
        name:'Tiffany Dining Chair',
        categorySlug : "chair"
    },
    {
        id:137,
        image:shop134,
        tag:'',
        price:'',
        name:'Tub Bistro Armchair',
        categorySlug : "chair"
    },
    {
        id:138,
        image:shop135,
        tag:'',
        price:'',
        name:'Webbing Dining Chair',
        categorySlug : "chair"
    },
    {
        id:139,
        image:shop136,
        tag:'',
        price:'',
        name:'Webbing Dining Chair',
        categorySlug : "chair"
    },
    {
        id:140,
        image:shop137,
        tag:'',
        price:'',
        name:'Webbing Dining Chair',
        categorySlug : "chair"
    },
    {
        id:141,
        image:shop138,
        tag:'',
        price:'',
        name:'Webbing Dining Chair',
        categorySlug : "chair"
    },
    {
        id:142,
        image:shop139,
        tag:'',
        price:'',
        name:'Webbing Dining Chair',
        categorySlug : "chair"
    },
    {
        id:143,
        image:shop140,
        tag:'',
        price:'',
        name:'Webbing Dining Chair',
        categorySlug : "chair"
    },
    {
        id:144,
        image:shop141,
        tag:'',
        price:'',
        name:'Webbing Dining Chair',
        categorySlug : "chair"
    },
    {
        id:145,
        image:shop142,
        tag:'',
        price:'',
        name:'Webbing Dining Chair',
        categorySlug : "chair"
    },
    {
        id:146,
        image:shop143,
        tag:'',
        price:'',
        name:'Yoseph Peel Dining Chair',
        categorySlug : "chair"
    },
    {
        id:147,
        image:shop145,
        tag:'',
        price:'',
        name:'Zb Rattan Chair',
        categorySlug : "chair"
    },
    {
        id:148,
        image:shop146,
        tag:'',
        price:'',
        name:'Zb Rattan Chair',
        categorySlug : "chair"
    },
    {
        id:149,
        image:shop147,
        tag:'',
        price:'',
        name:'Zb Rattan Chair',
        categorySlug : "chair"
    },
    {
        id:150,
        image:shop148,
        tag:'',
        price:'',
        name:'Zb Rattan Chair',
        categorySlug : "chair"
    },
    {
        id:151,
        image:shop149,
        tag:'',
        price:'',
        name:'Zb Rattan Chair',
        categorySlug : "chair"
    },
    {
        id:152,
        image:shop150,
        tag:'',
        price:'',
        name:'Zb Rattan Chair',
        categorySlug : "chair"
    },
    {
        id:153,
        image:shop151,
        tag:'',
        price:'',
        name:'Brew Dining Table',
        categorySlug : "table"
    },
    {
        id:154,
        image:shop152,
        tag:'',
        price:'',
        name:'Brew Dining Table',
        categorySlug : "table"
    },
    {
        id:155,
        image:shop153,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "table"
    },
    {
        id:156,
        image:shop154,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "table"
    },
    {
        id:157,
        image:shop155,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "table"
    },
    {
        id:158,
        image:shop156,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "table"
    },
    {
        id:159,
        image:shop157,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "table"
    },
    {
        id:160,
        image:shop158,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "table"
    },
    {
        id:161,
        image:shop159,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "table"
    },
    {
        id:162,
        image:shop160,
        tag:'',
        price:'',
        name:'Bryenka Bench',
        categorySlug : "table"
    },
    {
        id:163,
        image:shop161,
        tag:'',
        price:'',
        name:'Casabia Nested Table',
        categorySlug : "table"
    },
    {
        id:164,
        image:shop162,
        tag:'',
        price:'',
        name:'Casabia Nested Table',
        categorySlug : "table"
    },
    {
        id:165,
        image:shop163,
        tag:'',
        price:'',
        name:'Casabia Nested Table',
        categorySlug : "table"
    },
    {
        id:166,
        image:shop164,
        tag:'',
        price:'',
        name:'Casabia Nested Table',
        categorySlug : "table"
    },
    {
        id:167,
        image:shop165,
        tag:'',
        price:'',
        name:'Casabia Nested Table',
        categorySlug : "table"
    },
    {
        id:168,
        image:shop166,
        tag:'',
        price:'',
        name:'Casabia Nested Table',
        categorySlug : "table"
    },
    {
        id:169,
        image:shop167,
        tag:'',
        price:'',
        name:'Coffee Table Industria',
        categorySlug : "table"
    },
    {
        id:170,
        image:shop168,
        tag:'',
        price:'',
        name:'Glen Dining Table',
        categorySlug : "table"
    },
    {
        id:171,
        image:shop169,
        tag:'',
        price:'',
        name:'Glen Dining Table',
        categorySlug : "table"
    },
    {
        id:172,
        image:shop170,
        tag:'',
        price:'',
        name:'Glen Dining Table',
        categorySlug : "table"
    },
    {
        id:173,
        image:shop171,
        tag:'',
        price:'',
        name:'Glen Dining Table',
        categorySlug : "table"
    },
    {
        id:174,
        image:shop172,
        tag:'',
        price:'',
        name:'Glen Dining Table',
        categorySlug : "table"
    },
    {
        id:174,
        image:shop172,
        tag:'',
        price:'',
        name:'Glen Dining Table',
        categorySlug : "table"
    },
    {
        id:175,
        image:shop173,
        tag:'',
        price:'550,000.00',
        Heightdiameter : "DIAM. 52 x H 52 CM",
        material : "IRON FRAME = WHITE PC NATURAL RATTAN CORE / PITRIT : NATURAL",
        packaging : "Single Face Paper",
        name:'Lyon Nested Table Big',
        categorySlug : "table"
    },
    {
        id:176,
        image:shop174,
        tag:'',
        price:'',
        name:'Lyon Nested Table Big',
        categorySlug : "table"
    },
    {
        id:177,
        image:shop175,
        tag:'',
        price:'',
        name:'Lyon Nested Table Big',
        categorySlug : "table"
    },
    {
        id:178,
        image:shop176,
        tag:'',
        price:'',
        name:'Lyon Nested Table Big',
        categorySlug : "table"
    },
    {
        id:179,
        image:shop177,
        tag:'',
        price:'',
        name:'Lyon Nested Table Big',
        categorySlug : "table"
    },
    {
        id:180,
        image:shop177,
        tag:'',
        price:'',
        Heightdiameter : "DIAM. 39 x H 42 CM",
        material : "IRON FRAME = WHITE PC NATURAL RATTAN CORE / PITRIT : NATURAL",
        packaging : "Single Face Paper",
        name:'Lyon Nested Table Small',
        categorySlug : "table"
    },
    {
        id:181,
        image:shop178,
        tag:'',
        price:'',
        dimesi: {
            Heightdiameter : "",
            unit : ""
        },
        material : "",
        packaging : "",
        name:'Lyon Nested Table Small',
        categorySlug : "table"
    },
    {
        id:182,
        image:shop179,
        tag:'',
        price:'',
        name:'Lyon Nested Table Small',
        categorySlug : "table"
    },
    {
        id:183,
        image:shop180,
        tag:'',
        price:'',
        name:'Lyon Nested Table Small',
        categorySlug : "table"
    },
    {
        id:184,
        image:shop181,
        tag:'',
        price:'',
        name:'Lyon Nested Table Small',
        categorySlug : "table"
    },
    {
        id:185,
        image:shop182,
        tag:'',
        price:'',
        name:'Peacock Coffee Table',
        categorySlug : "table"
    },
    {
        id:186,
        image:shop183,
        tag:'',
        price:'',
        name:'Peacock Side Table',
        categorySlug : "table"
    },
    {
        id:187,
        image:shop184,
        tag:'',
        price:'',
        name:'Taylor Desk',
        categorySlug : "table"
    },
    {
        id:188,
        image:shop185,
        tag:'',
        price:'',
        name:'Taylor Desk',
        categorySlug : "table"
    },
    {
        id:189,
        image:shop186,
        tag:'',
        price:'',
        name:'Taylor Desk',
        categorySlug : "table"
    },
    {
        id:190,
        image:shop187,
        tag:'',
        price:'',
        name:'Taylor Desk',
        categorySlug : "table"
    },
    {
        id:191,
        image:shop188,
        tag:'',
        price:'',
        name:'Taylor Desk',
        categorySlug : "table"
    },
    {
        id:192,
        image:shop189,
        tag:'',
        price:'',
        name:'Taylor Desk',
        categorySlug : "table"
    },
    {
        id:193,
        image:shop190,
        tag:'',
        price:'',
        name:'Taylor Desk',
        categorySlug : "table"
    },
    {
        id:194,
        image:shop191,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:195,
        image:shop192,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:196,
        image:shop192,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:197,
        image:shop193,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:198,
        image:shop194,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:199,
        image:shop195,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:200,
        image:shop196,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:201,
        image:shop197,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:201,
        image:shop198,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:202,
        image:shop199,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:203,
        image:shop200,
        tag:'',
        price:'',
        name:'Bloom Lounge Sofa',
        categorySlug : "sofa"
    },
    {
        id:204,
        image:shop201,
        tag:'',
        price:'',
        name:'Anatolia Mirror',
        categorySlug : "mirror"
    },
    {
        id:205,
        image:shop202,
        tag:'',
        price:'',
        name:'Anatolia Mirror',
        categorySlug : "mirror"
    },
    {
        id:206,
        image:shop203,
        tag:'',
        price:'',
        name:'Anatolia Mirror',
        categorySlug : "mirror"
    },
    {
        id:207,
        image:shopPapasan1,
        tag:'',
        price:'2,400,000.00',
        Heightdiameter : "W 90x D 85 x H 85 CM",
        material : "NATURAL CANE TOP AND IRON LEG FRAME CUSHION CREAM CALICO - INDOOR",
        packaging : "FABRIC BY CASA SULIVAN @ RP. 30,000 PER METER",
        name:'Modified Papasan Chair',
        categorySlug : "chair"
    },
    {
        id:208,
        image:shopPapasan2,
        tag:'',
        price:'',
        name:'Modified Papasan Chair',
        categorySlug : "chair"
    },
    {
        id:209,
        image:shopPapasan3,
        tag:'',
        price:'',
        name:'Modified Papasan Chair',
        categorySlug : "chair"
    },
    {
        id:210,
        image:shopPapasan4,
        tag:'',
        price:'',
        name:'Modified Papasan Chair',
        categorySlug : "chair"
    },
    {
        id:211,
        image:shopPapasan5,
        tag:'',
        price:'',
        name:'Modified Papasan Chair',
        categorySlug : "chair"
    },
    {
        id:212,
        image:shopPapasan6,
        tag:'',
        price:'',
        name:'Modified Papasan Chair',
        categorySlug : "chair"
    },
    {
        id:213,
        image:shopPapasan7,
        tag:'',
        price:'',
        name:'Modified Papasan Chair',
        categorySlug : "chair"
    },
    {
        id:214,
        image:shopPapasan8,
        tag:'',
        price:'',
        name:'Modified Papasan Chair',
        categorySlug : "chair"
    },
    {
        id:215,
        image:royalArmChair,
        tag:'',
        price:'',
        name:'royal ArmChair',
        categorySlug : "chair"
    },

]
// MODIFIED-PAPASAN-CHAIR   LYON-NESTED-TABLE-SMALL PEACOCK-SIDE-TABLE 177-181 PEACOCK-COFFEE-TABLE
// PAUL-DINING-CHAIR  JUMA-CHAIR FLOWER-CHAIR HERRING-STOOL MORY-CHAIR-LIGHT-GREY MAX-DINING-CHAIR PAUL-BARSTOOL
// Borneo Hanging Chair

export const featureOne = [
    {
        id:1,
        image:fea1,
        title:'Free Shipping',
        desc:'Enjoy free shipping on all orders, making your shopping experience even more convenient. Get your favorite products delivered.'
    },
    {
        id:2,
        image:fea2,
        title:'Easy to Return',
        desc:`Experience hassle-free returns with our easy-to-use return policy. If you're not satisfied, simply return your product for a quick.`
    },
    {
        id:3,
        image:fea3,
        title:'Secure Payment',
        desc:`Shop with confidence using our secure payment options, ensuring your personal information stays protected. We prioritize your safety.`
    },
    {
        id:4,
        image:fea4,
        title:`Customer Support`,
        desc:`Our dedicated customer support team is here to assist you every step of the way. Reach out to us anytime for prompt, friendly help.`
    },
    {
        id:5,
        image:fea5,
        title:`Product QC Team`,
        desc:`Our meticulous product QC team ensures every item meets our highest standards. Trust in quality assurance that goes beyond expectation.`
    },
]

export const blogData = [
    {
        id:1,
        image:blog1,
        date:'13th Sept 2025',
        tag:'Chair',
        title:`Creating Your Dream Sanctuary: Inspirational Room Decor with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:2,
        image:blog2,
        date:'29th Dec 2025',
        tag:'Sofa',
        title:`From Drab to Fab: Room Makeover Inspiration by Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:3,
        image:blog3,
        date:'29th Nov 2025',
        tag:'Vases',
        title:`Small Space, Big Style: Room Decor Solutions from Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:4,
        image:blog4,
        date:'13th March 2025',
        tag:'Interior',
        title:`Innovative Room Decor: Unleashing Creativity with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:5,
        image:blog5,
        date:'5th May 2025',
        tag:'Chair',
        title:`Timeless Elegance: Classic Room Decor Ideas from Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:6,
        image:blog6,
        date:'19th June 2025',
        tag:'Sofa',
        title:`Budget-Friendly Brilliance: Room Decor Hacks by Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:7,
        image:blog7,
        date:'20th June 2025',
        tag:'Vases',
        title:`Personalize Your Space: Custom Room Decor Options with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:8,
        image:blog8,
        date:'31st Aug 2025',
        tag:'Lamp',
        title:`ransform Your Home: Room Decor Tips and Trends with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
]

export const partnerData = [
    {
        image:partner1,
        image2:partner01
    },
    {
        image:partner2,
        image2:partner02
    },
    {
        image:partner3,
        image2:partner03
    },
    {
        image:partner4,
        image2:partner04
    },
    {
        image:partner5,
        image2:partner05
    },
    {
        image:partner6,
        image2:partner06
    },
    {
        image:partner8,
        image2:partner08
    },
]

export const productSlider = [
    {
        image:product1,
        name:'Luxury Sofa Set',
        product:'26 Products'
    },
    {
        image:product2,
        name:'Table & Chair',
        product:'40 Products'
    },
    {
        image:product3,
        name:'Vases & Lamp',
        product:'14 Products'
    },
    {
        image:product4,
        name:'Interior Collection',
        product:'32 Products'
    },
    {
        image:product1,
        name:'Luxury Sofa Set',
        product:'26 Products'
    },
    {
        image:product2,
        name:'Table & Chair',
        product:'40 Products'
    },
]

export const teamData = [
    {
        image:team3,
        name:'ACTA Brasserie ',
        location:'The MAJ, Senayan',
        desc:`Very satisfying, all custom interior needs are as expected`
    },
    {
        image:team2,
        name:'PULLMAN ',
        location:'Hotel Orchard Singapore ',
        desc:`A variety of sofa choices and customization is also possible. CASA SULIVAN is extraordinary.`
    },
]
export const blogTwoData = [
    {
        id:1,
        image:blog01,
        date:'13th Sept 2025',
        tag:'Chair',
        title:`Creating Your Dream Sanctuary: Inspirational Room Decor with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:2,
        image:blog02,
        date:'29th Dec 2025',
        tag:'Sofa',
        title:`From Drab to Fab: Room Makeover Inspiration by Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:3,
        image:blog03,
        date:'29th Nov 2025',
        tag:'Vases',
        title:`Small Space, Big Style: Room Decor Solutions from Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:1,
        image:blog01,
        date:'13th Sept 2025',
        tag:'Chair',
        title:`Creating Your Dream Sanctuary: Inspirational Room Decor with Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
    {
        id:2,
        image:blog02,
        date:'29th Dec 2025',
        tag:'Sofa',
        title:`From Drab to Fab: Room Makeover Inspiration by Furnixar`,
        desc:`Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . .`
    },
]

export const pricingData = [
    {
        title:'Basic Plan',
        month:'$9',
        year:'$99',
        feature:[
            'Access one person',
            'Get access to 230+ Product',
            'Advance Security System'
        ]
    },
    {
        title:'Standard Plan',
        month:'$19',
        year:'$199',
        feature:[
            'Access two person.',
            'Get access to 230+ Product',
            'Advance Security System'
        ]
    },
    {
        title:'Premium Plan',
        month:'$99',
        year:'$999',
        feature:[
            'Access five person',
            'Get access to 230+ Product',
            'Advance Security System',
            'Buy one time get life time access',
            'Lorem ipsum dolor sit amet.'
        ]
    },
]

export const teamDataTwo = [
    {
        image:team01,
        name:'Luciana Sacchena',
        position:'Product Designer',
        desc:'Product designers are the creative architects behind the innovative solutions that shape our world.',
        class1:'order-1',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-2',
        delay:'100'
    },
    {
        image:team02,
        name:'Jamse Zuan',
        position:'CEO & Founder',
        desc:'As the visionary leader of our furniture eCommerce business, Emma Wilson ensures the overall strategic direction and growth of the company.',
        class1:'order-2',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-1',
        delay:'200'
    },
    {
        image:team03,
        name:'Flacxia Piano',
        position:'Interior Designer',
        desc:'Flacxia Piano ensures smooth daily operations and efficient logistics management. With his expertise in streamlining processes, he helps maintain a seamless supply chain',
        class1:'order-1 lg:order-2',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-2 lg:order-1',
        delay:'300'
    },
    {
        image:team04,
        name:'Luciana Sacchena',
        position:'Photographer',
        desc:'Luciana Sacchena oversees daily operations and ensures the seamless execution of business processes. With a keen eye for logistics and a strong background',
        class1:'order-2 lg:order-1',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-1 lg:order-2',
        delay:'400'
    },
    {
        image:team05,
        name:'Nathan',
        position:'Client Communication Executive',
        desc:'PAs the technical lead, Nathan ensures our website is always fast, secure, and user-friendly. He leads the development team in creating an optimized shopping experience for every visitor.',
        class1:'order-1',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-2',
        delay:'500'
    },
    {
        image:team06,
        name:'Porlo Matiana',
        position:'Marketing Specialist',
        desc:'Porlo Matiana heads our sales team, using his expertise to meet customer needs with personalized furniture recommendations. His leadership boosts our sales growth while ensuring customer satisfaction.',
        class1:'order-2',
        class2:'sm:flex items-center justify-center px-5 py-[30px] order-1',
        delay:'600'
    },
]

export const partnerDataTwo = [
    {
        image:partner1,
        image2:partner01,
        delay:'100'
    },
    {
        image:partner2,
        image2:partner02,
        delay:'200'
    },
    {
        image:partner3,
        image2:partner03,
        delay:'300'
    },
    {
        image:partner4,
        image2:partner04,
        delay:'400'
    },
    {
        image:partner5,
        image2:partner05,
        delay:'500'
    },
    {
        image:partner6,
        image2:partner06,
        delay:'600'
    },
    {
        image:partner7,
        image2:partner07,
        delay:'700'
    },
    {
        image:partner8,
        image2:partner08,
        delay:'800'
    },
    {
        image:partner9,
        image2:partner09,
        delay:'900'
    },
    {
        image:partner10,
        image2:partner010,
        delay:'1000'
    },
    {
        image:partner11,
        image2:partner011,
        delay:'1100'
    },
    {
        image:partner12,
        image2:partner012,
        delay:'1200'
    },
    {
        image:partner13,
        image2:partner013,
        delay:'1300'    
    },
    {
        image:partner14,
        image2:partner014,
        delay:'1400'
    },
    {
        image:partner15,
        image2:partner015,
        delay:'1500'
    },
]

export const cartData = [
    {
        image:cart1,
        tag:'Chair',
        name:'Modern Sofa Set',
        price:'$74',
        status:'Completed'
    },
    {
        image:cart2,
        tag:'Interior',
        name:'Classic Chair with Vase',
        price:'$34',
        status:'Pending'
    },
    {
        image:cart3,
        tag:'Light',
        name:'Luxury Hanging Lamp',
        price:'$33',
        status:'Cancel'
    },
    {
        image:cart4,
        tag:'Lamp',
        name:'Premium Quality Vase',
        price:'$48',
        status:'Completed'
    },
    {
        image:cart5,
        tag:'Interior',
        name:'Classic White Chair',
        price:'$88',
        status:'Completed'
    },
]

export const productListTwo = [
    {
        id:1,
        image:shop01,
        offer:true,
        price:'$122.75',
        category:['Interior'],
        name:'Classic Table Lamp'
    },
    {
        id:2,
        image:shop02,
        offer:false,
        price:'$122.75',
        category:['Table'],
        name:'Classic Table Lamp'
    },
    {
        id:3,
        image:shop03,
        offer:true,
        price:'$122.75',
        category:['Interior', 'Vase',],
        name:'Classic Table Lamp'
    },
    {
        id:4,
        image:shop04,
        offer:false,
        price:'$122.75',
        category:['Table', 'Design'],
        name:'Classic Table Lamp'
    },
    {
        id:5,
        image:shop05,
        offer:true,
        price:'$122.75',
        category:['Table'],
        name:'Classic Table Lamp'
    },
    {
        id:6,
        image:shop06,
        offer:false,
        price:'$122.75',
        category:['Vase'],
        name:'Classic Table Lamp'
    },
    {
        id:7,
        image:shop07,
        offer:false,
        price:'$122.75',
        category:['Table', 'Design'],
        name:'Classic Table Lamp'
    },
    {
        id:8,
        image:shop08,
        offer:false,
        price:'$122.75',
        category:['Vase'],
        name:'Classic Table Lamp'
    },
    {
        id:9,
        image:shop09,
        offer:false,
        price:'$122.75',
        category:[ 'Design'],
        name:'Classic Table Lamp'
    },
]

export const productTag = [
    'Chair',
    'Art & Paint',
    'Mirror',
    'Table',
    'Lamp'
]

export const venderInfo = [
    {
        name:'',
        vendor:'',
        shop:'',
        mail:'',
        call:''
    },
    {
        name:'',
        vendor:'',
        shop:'',
        mail:'',
        call:''
    },
]

export const detailReview = [
    {
        name:'',
        desc:`Casa sulivan products have transformed my living space with their stylish designs and impeccable craftsmanship.`
    },
    {
        name:'',
        desc:`Casa sulivan products have transformed my living space with their stylish designs and impeccable craftsmanship.`
    },
    {
        name:'',
        desc:`Casa sulivan products have transformed my living space with their stylish designs and impeccable craftsmanship.`
    },
]

export const shippingAbout = [
    {
        title:'For Shipping',
        desc:`Shipping times may vary based on your location and the selected delivery option. Please review our shipping policies for details on processing times, charges, and tracking updates. Contact us for any shipping-related inquiries or assistance.`
    },
    {
        title:'Item Return',
        desc:`We offer a hassle-free process to ensure your satisfaction. Please review our return policy for eligibility and steps to initiate a return. we offer a hassle-free process to ensure your satisfaction. Please review our return policy for eligibility and steps to initiate a return.`
    },
    {
        title:'Accepted Problem Issue',
        desc:`Choose from multiple methods, including credit cards, debit cards, and online payment gateways. All transactions are encrypted to ensure your information remains safe. For any payment-related concerns, our support team is here to assist.`
    },
]
